<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import ImagenQueueWidget from '../widgets/ImagenQueueWidget.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import { Imagenologia } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let cola = $state({ sol: 0, adq: 0, inf: 0 });

  async function cargar() {
    const [a, b, c] = await Promise.all([
      Imagenologia.ordenes('SOLICITADA').catch(() => []),
      Imagenologia.ordenes('ADQUIRIDA').catch(() => []),
      Imagenologia.ordenes('INFORMADA').catch(() => []),
    ]);
    cola = { sol: a.length, adq: b.length, inf: c.length };
  }

  const actions = [{ id: 'imagenologia', label: 'Ir a RIS', icon: '' }];

  $effect(() => { cargar(); const t = setInterval(cargar, 30000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Imagenología (RIS)" subtitle="Cola de estudios" variant="imagenologia">
  <DashHero emoji='' title="Imagenología (RIS)" subtitle="Adquisición, informe y entrega de estudios" variant="imagenologia" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <div class="dash-kpi"><div class="dash-kpi-label">Solicitadas</div><div class="dash-kpi-value">{cola.sol}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Adquiridas</div><div class="dash-kpi-value">{cola.adq}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Informadas</div><div class="dash-kpi-value">{cola.inf}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Total activo</div><div class="dash-kpi-value">{cola.sol + cola.adq + cola.inf}</div></div>
  </div>

  <div class="dash-grid">
    <div class="col-12"><ImagenQueueWidget limit={15} {onNavigate} /></div>
  </div>
</DashboardLayout>
